abstract class BaseComponent {
  constructor(public rootElement: HTMLElement) {
    setTimeout(() => {
      this.init();
    }, 0);
  }

  public abstract init(): void;
}

export { BaseComponent };
